import {useQuery} from '@tanstack/react-query'
import {RangeOfDates} from 'src/pages/dashboard/components/PersonalizedDatesRange'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  enabled?: boolean
  filter: {
    companyIds?: Array<number>
  }
  range: RangeOfDates
}

export default function useGetSyntheticData({enabled, filter, range}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_PERSONALIZED_SYNTHETIC_DATA, filter, enabled, range],
    queryFn: async () => (await api.reports.getSyntheticData({filter, actual: range.actual, last: range.last})).data.data,
  })

  return query
}
